import { Button, Modal } from 'antd';
import React, { Component } from 'react';

class ModalSlipImage extends Component {
  render() {
    const { visible, onClose, imgPath, title } = this.props;
    const footer = [
      <Button key="cancel" onClick={onClose}>
        ปิด
      </Button>,
    ];

    return (
      <Modal
        visible={visible}
        title={title || 'สลิปแจ้งโอนเงิน'}
        onCancel={onClose}
        maskClosable={false}
        style={{ top: 20 }}
        footer={footer}
        width={800}
      >
        <img src={imgPath} alt="" style={{ width: '100%' }} />
      </Modal>
    );
  }
}

export default ModalSlipImage;



// WEBPACK FOOTER //
// ./src/containers/Payment/modal-slip-image.js